import api from "./axios";

export const getProducts = async (
  subscriptionId: string,
  compatibleId: string,
  facilityId: string
) => {
  return await api.get("/api/ems/get-products", {
    params: {
      subscriptionId: subscriptionId,
      compatibleId: compatibleId,
      facility: facilityId,
      categories: "additional",
      statuses: "Published",
    },
  });
};
